import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight, FaFingerprint } from "react-icons/fa";
import HorizontalImageStrip from "./HorizontalImagesStrip";
import { GiCctvCamera, GiLockedDoor } from "react-icons/gi";
import { MdAddAlert } from "react-icons/md";
import { TbDeviceLandlinePhone } from "react-icons/tb";

export default function HomeBanner2(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		// initializations...
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	

	if (ready) {
		return (
			<div 
				className="MainBodySection bg-secondary"
				style={{
					paddingTop: "50px",
					paddingBottom: "50px"
				}}
			>
				
				<div 
					className="container"
					
				>
					<div className="row">

						<div className="col-md-12">
							
							<h1
								style={{
									fontSize: "22px",
									paddingTop: "30px",
									paddingBottom: "30px"
								}}
								className="font-light text-center"
							>
								The Foundation for Poverty Alleviation and Development Initiatives (FPADI) is a non-governmental organization (NGO) dedicated to combating poverty and fostering sustainable development in underprivileged communities.<br/><br/>
								FPADI focuses on empowering marginalized populations through programs that enhance access to essential services such as education, healthcare, and economic opportunities. The organization's initiatives are designed to address the root causes of poverty, promote self-reliance, and improve the overall quality of life for vulnerable groups
							</h1>

						</div>


						

						
					</div>

					
				</div>
					
				
			</div>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
